import { render, staticRenderFns } from "./view-actividades.vue?vue&type=template&id=b10a1066"
import script from "./view-actividades.vue?vue&type=script&lang=js"
export * from "./view-actividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports